import { useTranslations } from '@vocab/react';
import { ButtonLink, Stack, Text } from 'braid-design-system';

import type { AnalyticsVerificationsWidgetCallToAction } from 'src/modules/analytics/types';

import { verifiableNudgeCredentialTypenameToCallToAction } from '../analyticsUtils';
import type {
  VerifiableNudgeCredentialTypename,
  VerificationsNudgeVerifiableCredential,
} from '../types';

import translations from './.vocab';

interface NudgeProps {
  credential: VerificationsNudgeVerifiableCredential;
  analyticsOnClick: (props: {
    callToAction: AnalyticsVerificationsWidgetCallToAction;
  }) => void;
}

export const SeekPassCredentialNudge = ({
  credential,
  analyticsOnClick,
}: NudgeProps) => {
  const { t } = useTranslations(translations);

  const { __typename, url } = credential;

  const verificationToNudgeButtonText: Record<
    VerifiableNudgeCredentialTypename,
    string
  > = {
    IdentityVerifiableCredential: t('Verify your identity'),
    WorkplaceVerifiableCredential: t('Verify career history'),
  };

  const onClick = () => {
    const callToAction =
      verifiableNudgeCredentialTypenameToCallToAction[__typename];
    analyticsOnClick({
      callToAction,
    });
  };

  return (
    <>
      <Stack space="medium">
        <Text tone="secondary">
          {t('Profiles with verifications are more likely to be selected.')}
        </Text>
        <ButtonLink
          href={url}
          onClick={onClick}
          target="_blank"
          data={{
            automation: 'verifications-card-nudge-verify-button',
          }}
        >
          {verificationToNudgeButtonText[__typename]}
        </ButtonLink>
      </Stack>
    </>
  );
};
